import { render } from "./editCard.vue?vue&type=template&id=974ac1b6&scoped=true&ts=true"
import script from "./editCard.vue?vue&type=script&lang=ts"
export * from "./editCard.vue?vue&type=script&lang=ts"

import "./editCard.vue?vue&type=style&index=0&id=974ac1b6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974ac1b6"]])

export default __exports__